import { SWRConfiguration } from "swr"
import { fetcher } from "./fetcher"

/**
 * Global SWR configuration
 *
 * This configuration provides:
 * - Authentication-aware fetcher with session cookies
 * - Automatic revalidation on focus and reconnect
 * - Error retry with exponential backoff
 * - Request deduplication
 */
export const swrConfig: SWRConfiguration = {
  fetcher: fetcher,
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  shouldRetryOnError: true,
  errorRetryCount: 3,
  errorRetryInterval: 1000, // Initial retry interval in ms (exponential backoff handled by SWR)
  dedupingInterval: 2000, // Dedupe requests within 2 seconds
}
